import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import ServiceScheduleUpdate from './ServiceScheduleUpdate';
import {
	ServiceSchedule,
	ServiceScheduleItem,
} from '../../../../graphql/graphql';
import { Moment } from 'moment';

interface Props extends BaseModalProps {
	selectedDate: Moment;
	serviceSchedule: ServiceSchedule;
	serviceScheduleItem: ServiceScheduleItem;
	onSuccess: () => void;
	onDelete: () => void;
}

const ServiceScheduleUpdateModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='base.editShiftsSchedule'>
			<ServiceScheduleUpdate
				selectedDate={props.selectedDate}
				onSuccess={props.onSuccess}
				serviceSchedule={props.serviceSchedule}
				serviceScheduleItem={props.serviceScheduleItem}
				onDelete={props.onDelete}
			/>
		</BaseModal>
	);
};

export default ServiceScheduleUpdateModal;
